import Cookies from 'js-cookie'

/**
 * 获取token
 * @returns {*}
 */
export const getToken = () => {
  return Cookies.get('token')
}

/**
 * 设置token
 * @param item
 * @returns {*}
 */
export const setToken = item => {
  return Cookies.set('token', item, { expires: 30 })
}

/**
 * 移除token
 * @returns {void | Promise<void>}
 */
export const removeToken = () => {
  return Cookies.remove('token')
}



// WEBPACK FOOTER //
// ./src/libs/session.js